import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { MoreActionMenuItem } from "models/propTypes/menuPropTypes";
import { StyleEnums } from "models/enums";
import { SnackbarKey } from "notistack";
//#endregion
//#region components
import { Grid, CircularProgress } from "@mui/material";
import useFloatingMessages from "../messages/useFloatingMessages";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

function useMenuButtonClick(onActionSuccess?: (result?: any) => void, onError?: (error: any) => void) {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const { enqueueMessage, closeMessage } = useFloatingMessages();

  const handleMenuItemClick = (
    menuItem: MoreActionMenuItem,
    disableSuccessMessages: boolean,
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    event.stopPropagation();
    menuItem.actionDialog &&
      dispatch(
        displayDialog({
          ...menuItem.actionDialog,
          onSubmit: menuItem.actionDialog.onSubmit ?? menuItem.onActionSuccess ?? onActionSuccess,
          disbleSuccessMessages: disableSuccessMessages,
        })
      );

    if (menuItem.onClickHandler) {
      let progressMessageKey: SnackbarKey;
      if (menuItem.inProgressMessage) {
        progressMessageKey = enqueueMessage(
          <Grid container direction="row">
            <Grid item className={cssExports.loadingIconContainer}>
              <CircularProgress size={20} className={cssExports.loadingIcon} />
            </Grid>
            <Grid item>{LocalizationHelperInstance.getFormattedMessage(menuItem.inProgressMessage)}</Grid>
          </Grid>,
          StyleEnums.DisplayType.Info
        );
      }

      menuItem
        .onClickHandler()
        .then((res) => {
          if (!disableSuccessMessages && menuItem.successMessage) {
            enqueueMessage(
              LocalizationHelperInstance.getFormattedMessage(menuItem.successMessage, menuItem.successMessage),
              StyleEnums.DisplayType.Success
            );
          }
          (menuItem.onActionSuccess && menuItem.onActionSuccess(res)) || (onActionSuccess && onActionSuccess(res));
        })
        .catch((error) => {
          onError && onError(error);
        })
        .finally(() => {
          progressMessageKey && closeMessage(progressMessageKey);
        });
    }
  };

  return handleMenuItemClick;
}

export default useMenuButtonClick;
